import React from "react";

function TermsOfUsePage() {
  return (
    <div className="container cookies-page-container">
      <div className="cookies-page-header">
        <img src="/logo.png" alt="Student Loan Modeller Logo" className="page-logo" />
        <h1 className="main-title cookies-page-title">Website Terms of Use</h1>
        <p className="app-intro cookies-page-intro">
          These terms set out the rules for using the Student Loan Amount Modeller (SLAM) website.
        </p>
      </div>

      <section className="cookies-section">
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using SLAM, you agree to these Terms of Use. If you do not agree, you should
          not use the website.
        </p>
        <p className="policy-effective-date"><strong>Last updated:</strong> 18 August 2026</p>
      </section>

      <section className="cookies-section">
        <h2>2. Permitted Use</h2>
        <p>You may use SLAM only for lawful personal or informational purposes.</p>
        <ul className="cookies-detail-list">
          <li>Do not misuse, disrupt, or attempt to gain unauthorised access to the website.</li>
          <li>Do not use the website in any way that breaches applicable laws or regulations.</li>
          <li>
            Do not rely on SLAM as a substitute for professional financial, legal, tax, or other
            regulated advice.
          </li>
        </ul>
      </section>

      <section className="cookies-section">
        <h2>3. Intellectual Property</h2>
        <p>
          Unless otherwise stated, SLAM&apos;s own content, layout, text, branding, and calculator
          methodology are protected by intellectual property rights and remain the property of SLAM
          and/or its licensor(s).
        </p>
        <p>
          You may view and use this material for personal, non-commercial purposes. You must not copy,
          reproduce, republish, distribute, modify, reverse engineer, or create derivative works from
          SLAM&apos;s own content or calculator methodology except where permitted by law or with prior
          written permission.
        </p>
      </section>

      <section className="cookies-section">
        <h2>4. Relationship With Disclaimer</h2>
        <p>
          These Terms of Use apply in addition to, and do not replace, the SLAM disclaimer available on the
          full disclaimer page and in the mandatory acceptance prompt shown before calculator use.
          Both apply together to your use of SLAM.
        </p>
      </section>

      <section className="cookies-section">
        <h2>5. Donations and Support Payments</h2>
        <p>
          Any donation or support payment you choose to make (including via Buy Me a Coffee) is entirely
          voluntary. Donations do not purchase a product or service, are not required to use SLAM, and
          are non-refundable unless required by applicable law.
        </p>
      </section>

      <section className="cookies-section">
        <h2>6. Governing Law and Jurisdiction</h2>
        <p>
          These Terms of Use and any dispute or claim arising out of or in connection with them (including
          non-contractual disputes or claims) are governed by the laws of England and Wales.
        </p>
        <p>
          You and SLAM agree that the courts of England and Wales shall have exclusive jurisdiction,
          except where mandatory consumer law in your place of residence provides otherwise.
        </p>
      </section>

      <section className="cookies-section">
        <h2>7. Changes to These Terms</h2>
        <p>
          SLAM may update these Terms of Use from time to time. Any updates will be posted on this page
          with a revised date.
        </p>
      </section>

      <div className="cookies-actions">
        <a className="cookie-btn cookie-btn-secondary" href="/privacy">
          Privacy policy
        </a>
        <a className="cookie-btn cookie-btn-secondary" href="/cookies">
          Cookies page
        </a>
        <a className="cookie-btn cookie-btn-primary" href="/">
          Back to calculator
        </a>
      </div>
    </div>
  );
}

export default TermsOfUsePage;